<template>
	<div class="form-element" :style="margin" :id="advanced.cssId"
	     :class="[{'required':required}, basic.inputType, advanced.cssClasses, responsiveClasses]">
		<label class="fe-label" :style="labelStyle"
		       v-if="showLabels && basic.inputType !== 'checkbox' && basic.inputType !== 'radio' && basic.inputType !== 'double'">
			{{ basic.label ? basic.label : 'Label' }}
		</label>

		<input
				type="text"
				:name="props.dataType"
				:data-type="props.dataType"
				:data-name="props.dataName"
				:data-auto_optin="props.auto_optin"
				:placeholder="props.placeholder"
				v-if="!basic.inputType || basic.inputType === 'input'"
				:style="style">

		<textarea
				:name="props.dataType"
				:data-type="props.dataType"
				:data-name="props.dataName"
				:placeholder="props.placeholder"
				v-if="basic.inputType === 'textarea'"
				:style="style"></textarea>

		<input v-if="basic.inputType === 'number'"
		       type="number"
		       :name="props.dataType"
		       :data-type="props.dataType"
		       :data-name="props.dataName"
		       :placeholder="props.placeholder"
		       value="0"
		       :style="style" >

		<label v-if="basic.inputType === 'checkbox'"
		       class="layout-row flex-center"
		       :style="style" >
			<input type="checkbox" :name="props.dataType"
			       :data-type="props.dataType"
			       :data-name="props.dataName"
			       :value="props.value">
			<span class="fe-label" :class="{required}" :style="labelStyle" >{{ basic.label || '' }}</span>
		</label>

		<label v-if="basic.inputType === 'radio'"
		       class="layout-row flex-center"
		       :style="style"  >
			<input type="radio" :name="props.dataType+'_'+props.dataName"
			       :data-type="props.dataType"
			       :data-name="props.dataName"
			       :value="props.value">
			<span class="fe-label" :class="{required}" :style="labelStyle" >{{ basic.label || '' }}</span>
		</label>

		<div class="fe-select" :style="style" v-if="basic.inputType === 'select'">
			<select
					:class="selectClasses"
					:name="props.dataType"
					:data-type="props.dataType"
					:data-name="props.dataName"
					:data-options="props.optionsType"
					:data-placeholder="props.placeholder"
					v-if="basic.inputType === 'select'">
				<option v-if="props.optionsType==='custom' && props.placeholder" value="" disabled selected>
					{{ props.placeholder }}
				</option>
				<option v-if="props.optionsType==='custom'" :value="item.name" v-for="(item, index) in props.options">
					{{ item.value }}
				</option>
			</select>
		</div>

		<div class="fe-double" v-if="basic.inputType === 'double'">
			<div class="fe-input-wrpr">
				<label class="fe-label" v-if="showLabels" :class="{required}" :style="labelStyle">
					{{ basic.label || 'Label' }}
				</label>
				<input type="text"
				       :name="props.dataType"
				       :data-type="props.dataType"
				       :data-name="props.dataName"
				       :data-auto_optin="props.auto_optin"
				       :placeholder="props.placeholder"
				       :style="style">
			</div>
			<div class="fe-input-wrpr">
				<label class="fe-label" v-if="showLabels" :class="{required}" :style="labelStyle">
					{{ basic.label2 || 'Label' }}
				</label>
				<input type="text"
				       :name="props.dataType2"
				       :data-type="props.dataType2"
				       :data-name="props.dataName2"
				       :data-auto_optin="props.auto_optin"
				       :placeholder="props.placeholder2"
				       :style="style">
			</div>
		</div>

	</div>
</template>

<script>
import {mapGetters} from "vuex"
import {borderProps, boxShadow, getPadding, textDecoration} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailFormElement',
	props: ['id', 'details', 'options'],
	data: function () {
		return {
			localData: {
				value: '',
				options: [],
			},
		}
	},
	computed: {
		...mapGetters(['page_findOne', 'page_findChild']),
		content() {
			return this.details
		},
		basic() {
			return this.content.attributes.basic
		},
		advanced() {
			return this.content.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		props(){
			return this.basic.props || {};
		},
		required(){
			return this.props.required;
		},
		selectClasses(){
			switch (this.props.optionsType) {
				case 'countries':
					return 'fe-countries'
				case 'states':
					return 'fe-states'
				case 'cities':
					return 'fe-cities'
				default:
					return ''
			}
		},
		showLabels(){
			return this.props.showLabel;
		},
		selectOption() {
			return this.options ? this.options : this.localData.options
		},
		margin() {
			return {
				margin: getPadding(this.basic.margin),
			}
		},
		labelStyle() {
			let fontFamily = this.basic.labelFont ? this.basic.labelFont.fontFamily : null;
			let fontSize = this.basic.labelFont ? this.basic.labelFont.fontSize : null;
			let textAlign = this.basic.labelFont ? this.basic.labelFont.textAlign : 'left';
			let fontStyling = this.basic.labelFont ? this.basic.labelFont.fontStyling : null;
			let color = this.basic.labelFont ? this.basic.labelFont.color : '#252A32';

			return {
				color,
				fontFamily,
				fontSize: fontSize ? fontSize + 'px' : null,
				textAlign,
				fontWeight: fontStyling && fontStyling.bold ? 'bold' : 'normal',
				fontStyle: fontStyling && fontStyling.italic ? 'italic' : 'normal',
				textDecoration: textDecoration(this.basic.labelFont),
			}
		},
		style() {
			let {
				borderTop,
				borderLeft,
				borderRight,
				borderBottom,
				borderRadius,
				borderColor
			} = borderProps(this.basic.border)

			var transform = this.advanced.transformation ?
					'rotateX(' + this.advanced.transformation.rotateX + 'deg) ' +
					'rotateY(' + this.advanced.transformation.rotateY + 'deg) ' +
					'rotateZ(' + this.advanced.transformation.rotateZ + 'deg) ' +
					'scale3d(' + this.advanced.transformation.scaleX + ', ' + this.advanced.transformation.scaleY + ', ' + this.advanced.transformation.scaleZ + ')' : null;

			var transition = this.advanced.animations ?
					this.advanced.animations.duration + 's ' +
					this.advanced.animations.property + ' ' +
					this.advanced.animations.easing : null;

			var fontFamily = this.basic.font ? this.basic.font.fontFamily : null;
			var fontSize = this.basic.font ? this.basic.font.fontSize : null;
			var textAlign = this.basic.font ? this.basic.font.textAlign : 'left';
			var fontStyling = this.basic.font ? this.basic.font.fontStyling : null;
			var color = this.basic.font ? this.basic.font.color : '#252A32';

			return {
				backgroundColor: this.basic.backgroundColor || '#FFFFFF',
				borderRadius,
				borderTop,
				borderLeft,
				borderRight,
				borderBottom,
				borderColor,
				color,
				fontFamily,
				fontSize: fontSize ? fontSize + 'px' : null,
				textAlign,
				fontWeight: fontStyling && fontStyling.bold ? 'bold' : 'normal',
				fontStyle: fontStyling && fontStyling.italic ? 'italic' : 'normal',
				textDecoration: textDecoration(this.basic.font),
				boxShadow: boxShadow(this.basic.shadows),
				transform,
				transition,
			};
		},
	},
	methods: {},
	mounted() {
	}
}
</script>
